module.exports = __webpack_public_path__ + "static/media/logo@2x.61bf8489.png";